import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Column,
  DataGrid,
  Selection,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  SearchPanel,
} from "devextreme-react/data-grid";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button1 from "@material-ui/core/Button";
import swal from "sweetalert";
import { saveAs } from "file-saver-es";
import axios from "axios";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import { api_path } from "../../shared.js";
import ReactHtmlParser from "react-html-parser";
import Select from "react-select";
const url_carrier = api_path + "/MS_CARRIER_CONTACT.php";
export function SendInquiryForm(props) {
  const [searchParams] = useSearchParams();
  const order_id = searchParams.get("order_id");
  const getUserEmail = props.USER_EMAIL;
  const [GET_STATUS_ID, SET_STATUS_ID] = useState("");
  const [GET_SUBJECT_MAIL, SET_SUBJECT_MAIL] = useState("");
  const [GET_TO_MAIL, SET_TO_MAIL] = useState("");
  const [GET_CC_MAIL, SET_CC_MAIL] = useState("");
  const [GET_BODY_MAIL, SET_BODY_MAIL] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showTEU, setShowTEU] = useState(false);
  const [teuData, setTeuData] = useState([]);
  const showTeuData = true;
  const [getPorName, setPorName] = useState("");
  const [getPodName, setPodName] = useState("");
  const [getPolName, setPolName] = useState("");
  const [getDelName, setDelName] = useState("");
  const [GET_BUTTON_STR, SET_BUTTON_STR] = useState("");
  
    const [getCarrier, setCarrier] = useState([]);
    const [carrierList, setCarrierList] = useState([]);
    const [selectCarrier, setSelectCarrier] = useState([]);
    useEffect(() => {
      const getTeuData = async () => {
        const resstate = await fetch(
          api_path +
            `/TS_SALES_INQUIRY_TEU.php?id=${order_id}`
        );
        const getst = resstate.json();
        setTeuData(await getst);
      };
      getTeuData().then();
    }, [order_id]);
  const fetchCarrier = () => {
        axios
          .get(api_path + `/MS_CARRIER_CONTACT.php?GET_CARRIER=1`)
          .then((response) => {
            setCarrierList(response.data);
          })
          .catch((err) => {
            console.log(err);
          });
      };
  useEffect(() => {
    fetchCarrier();
    let mailHtm_detail = "";
    fetch(api_path + "/TS_SALES_INQUIRY_BY_ID.php?param1=" + order_id)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        let cnt=0;
        for (const i of array) {
          cnt++;
          if (i.INQUIRY_ID) {
            setButtonDisabled(true);
            SET_STATUS_ID(i.STATUS_ID)
            if(i.STATUS_ID==1){
              SET_BUTTON_STR("Save data and update status to processing")
            }else{
              SET_BUTTON_STR("Save data")
            }
            
            if (i.POR_NAME == null) {
              setPorName("-");
            } else {
              setPorName("(" + i.POR_NAME + ")");
            }
            if (i.POD_NAME == null) {
              setPodName("-");
            } else {
              setPodName("(" + i.POD_NAME + ")");
            }
            if (i.POL_NAME == null) {
              setPolName("-");
            } else {
              setPolName("(" + i.POL_NAME + ")");
            }
            if (i.DEL_NAME == null) {
              setDelName("-");
            } else {
              setDelName("(" + i.DEL_NAME + ")");
            }
            if(cnt==1){
            mailHtm_detail += "<!DOCTYPE html><html><head>";
            mailHtm_detail += "<style>";
            mailHtm_detail +=
              "table, th, td {padding:2px;margin:0px;border:1px solid #EBEBEB; border-collapse: collapse;text-align:left;font-size:12px;}";
            mailHtm_detail += " td{margin:4px;} .p {font-size:12px!important;}";
            mailHtm_detail += " .bold {font-weight:bold;}";
            mailHtm_detail += " .boxx {border:none!important;}";
            mailHtm_detail += "</style>";
            mailHtm_detail += "</head><body>";
                     mailHtm_detail +="<br/><br/><br/>"
            }
   
            mailHtm_detail += "<table width='50%'>";
            mailHtm_detail += "<colgroup>";
            mailHtm_detail += "<col span='1' style='width: 20%;'>";
            mailHtm_detail += "<col span='1' style='width: 80%;'>";
            mailHtm_detail += "</colgroup><tbody>";
            if(cnt==1){
            mailHtm_detail +=
              "<tr><td class='bold'>SHIPPER NAME:  </td><td>" +
              i.Customer_name +
              "</td></tr>";
            
            mailHtm_detail +=
              "<tr><td class='bold'>POR:  </td><td>";
              if (i.POR_NAME == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.POR_NAME;
              }
              mailHtm_detail += "</td></tr>";

              mailHtm_detail +=
              "<tr><td class='bold'>POL:  </td><td>";
              if (i.POL_NAME == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.POL_NAME;
              }
              mailHtm_detail += "</td></tr>";


              mailHtm_detail +=
              "<tr><td class='bold'>DESTINATION:  </td><td>";
              if (i.DESTINATION_NAME == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.DESTINATION_NAME;
              }
              mailHtm_detail += "</td></tr>";

              mailHtm_detail +=
              "<tr><td class='bold'>POD:  </td><td>";
              if (i.POD_NAME == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.POD_NAME;
              }
              mailHtm_detail += "</td></tr>";
        
              mailHtm_detail +=
              "<tr><td class='bold'>DEL:  </td><td>";
              if (i.DEL_NAME == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.DEL_NAME;
              }
              mailHtm_detail += "</td></tr>";

            mailHtm_detail +=
              "<tr><td class='bold'>COMMODITY: </td><td>" +
              i.COMMODITY +
              "</td></tr>";
            mailHtm_detail +=
              "<tr><td class='bold'>COMMODITY DETAIL:  </td><td>" +
              i.COMMODITY_DETAIL +
              "</td></tr>";
              mailHtm_detail +=
              "<tr><td class='bold'>DANGEROUS: </td><td>" +
              i.DANGEROUS +
              "</td></tr>";
              mailHtm_detail +=
              "<tr><td class='bold'>DG CLASS/UN NO: </td><td>" +
              i.DG_CLASS +
              "</td></tr>";
              mailHtm_detail +=
              "<tr><td class='bold'>TARGET RATE: </td><td>" +
              i.TARGET_RATE +
              "</td></tr>";
              mailHtm_detail +=
              "<tr><td class='bold'>Expect ETD date / ETA: </td><td>" +
              i.EXPECT_ETD +
              "</td></tr>";

              mailHtm_detail +=
              "<tr><td class='bold'>REMARK:  </td><td>";
              if (i.REMARK_TO_CARRIER == null) {
                mailHtm_detail += '-';
              } else {
                mailHtm_detail += i.REMARK_TO_CARRIER;
              }
              mailHtm_detail += "</td></tr>"; 
            }
           
            mailHtm_detail +=
            "<tr><td colspan='2'><table class='boxx' width='100%'>";
            if(cnt==1){
            mailHtm_detail +=
            "<thead><tr><th>SIZE</th><th>TYPE</th><th>QTY</th><th>NOTE</th></tr></thead>";
            }
                mailHtm_detail += "<tbody><tr>";
                mailHtm_detail += "<td width='25%'>" + i.CTNR_SIZE + "</td>";
                mailHtm_detail += "<td width='25%'>" + i.CTNR_TYPE + "</td>";
                mailHtm_detail += "<td width='25%'>" + i.CTNR_QTY + "</td>";
                mailHtm_detail += "<td width='25%'>" + i.INQUIRY_TEU_NOTE + "</td>";
                mailHtm_detail += "</tr></tbody>";
              
            mailHtm_detail += "</table></td></tr>";
            if(cnt==1){
            mailHtm_detail += "</tbody></table>";
       
              mailHtm_detail += "</body></html>";
            }
            SET_CC_MAIL("");
            SET_BODY_MAIL(mailHtm_detail);
            SET_SUBJECT_MAIL(
              "SINO INQUIRY | ID :  " +
                order_id +
                " " +
                i.Customer_name +
                " / Port " +
                i.POD_NAME +
                " " +
                i.Business_name +
                ""
            );
          } else {
            setButtonDisabled(false);
            SET_TO_MAIL("");
            SET_CC_MAIL("");
            SET_SUBJECT_MAIL("");
            SET_BODY_MAIL("");
          }
        }
      });
  }, []);
  const [errors, setErrors] = useState({});
  const validateForm3 = () => {
    const errors = {};

    // if (!GET_TO_MAIL) {
    //   errors.ToMail = "Required";
    // }
    if (!GET_SUBJECT_MAIL) {
      errors.SubjectMail = "Required";
    }
    return errors;
  };
  const handleSubmitxxx = (event) => {
    event.preventDefault();
    makeOutlookFile(
      GET_BODY_MAIL,
      GET_TO_MAIL,
      GET_CC_MAIL,
      GET_SUBJECT_MAIL
    );
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    if(GET_STATUS_ID==1){
    const newErrors = validateForm3();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      swal({
        title: "Are you sure?",
        text: "to save data.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          var data = {
            USERID: getUserEmail,
            STATUS_ID: 2,
            STATUS_COMMENT: "Update status by send inquiry to carrier",
            FEEDBACK: "",
            INQUIRY_ID: order_id,
          };
          fetch(api_path + "/TS_SALES_INQUIRY_ITEM.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result["status"] == "200") {
                makeOutlookFile(
                  GET_BODY_MAIL,
                  GET_TO_MAIL,
                  GET_CC_MAIL,
                  GET_SUBJECT_MAIL
                );
                swal("Done.", "", "success", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  const url =
                    api_path +
                    "/SENDMAIL_INQUIRY_PROCESS.php?INQUIRY_ID=" +
                    order_id;
                  axios
                    .get(url)
                    .then((response) => {
                      // handle success
                      console.log(result["message"]);
                    })
                    .then((data) => {
                      console.log(data);
                      // Handle data
                    })
                    .catch((error) => {
                      // handle errors
                    });
                  window.location = "./SaleInquiryDetail?param1=" + order_id;
                });
              } else {
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                });
               
              }
            });

          ////////////////////////////////
        }
      });
    }
  }else{
    makeOutlookFile(
      GET_BODY_MAIL,
      GET_TO_MAIL,
      GET_CC_MAIL,
      GET_SUBJECT_MAIL
    );
  }
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  const Mailto = ({ email, ccmail, subject, body, children }) => {
    return (
      <a
        href={`mailto:${email}?subject=${
          encodeURIComponent(subject) || ""
        }&body=${encodeURIComponent(body) || ""}`}
        className="btn MuiButton-containedPrimary"
      >
        <span className="MuiButton-label">{children}</span>
      </a>
    );
  };

  function makeOutlookFile(bodyMail, emailto, emailCc, emailsubject) {
    var emlCont = "To: " + emailto + "\n";
    emlCont += "CC: " + emailCc + "\n";
    emlCont += "Subject: " + emailsubject + "\n";
    emlCont += "X-Unsent: 1" + "\n";

    emlCont += "Content-Type: text/html; charset=UTF-8" + "\n";
    emlCont += "" + "\n";
    emlCont += bodyMail;

    console.log(emlCont);
    var textFile = null;
    var data = new Blob([emlCont], { type: "text/plain" });
    if (textFile !== null) {
      window.URL.revokeObjectURL(textFile);
    }

    textFile = window.URL.createObjectURL(data);
    console.log(textFile);
    saveAs(data, emailsubject + ".eml");
  }
  const [getTotalCount, setTotalCount] = useState();
  const cellPrepared = (e) => {
    setTotalCount(e.component.totalCount());
  };
  const dataSourceCustomerEmail = createStore({
    key: "CONTACT_ID",
    loadUrl: `${url_carrier}`,
    loadParams: { CARRIER: selectCarrier },
  });
  const dataGridRef = useRef(null);
  const getEmployeeName = (row) => `${row.CONTACT_EMAIL}`;
  const getEmployeeNames = (selectedRowsData) =>
    selectedRowsData.length
      ? selectedRowsData.map(getEmployeeName).join(", ")
      : "";
  const [prefix, setPrefix] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState("");
  const onSelectionChanged = useCallback(
    ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
      setPrefix(null);
      setSelectedRowKeys(changedRowKeys);
      setSelectedEmployeeNames(getEmployeeNames(selectedRowsData));
      SET_TO_MAIL(getEmployeeNames(selectedRowsData));
    },
    []
  );
  const handleCarrierChange = (obj) => {
    setSelectCarrier(obj.value);
    setCarrier({
      value: obj.value,
      label: obj.label,
    });
  };
  return (
    <Container maxWidth="md" className="BorderBox">
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
          <label className="head">Send Inquiry</label>
            
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>To: </label>
            <TextField
              size="small"
              name="GET_TO_MAIL"
              variant="standard"
              fullWidth
              id="GET_TO_MAIL"
              value={GET_TO_MAIL}
              onChange={(e) => SET_TO_MAIL(e.target.value)}
            />

            {errors.ToMail && (
              <span className="error-message">{errors.ToMail}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>CC: </label>
            <TextField
              size="small"
              name="GET_CC_MAIL"
              variant="standard"
              fullWidth
              id="GET_CC_MAIL"
              value={GET_CC_MAIL}
              onChange={(e) => SET_CC_MAIL(e.target.value)}
            />
          </Grid>
         
          <Grid item xs={12} sm={3}>
          <label>Carrier </label>
          <Select
          className="multiselect1"
                          placeholder="Select..."
                          defaultValue={{
                            value: "ANL",
                            label: "ANL",
                          }}
                          value={getCarrier}
                          options={carrierList}
                          onChange={handleCarrierChange}
                         // required
                        />
                            </Grid>
                            <Grid item xs={12} sm={9}>    </Grid>
          <Grid item xs={12} sm={12}>
  
          
            <DataGrid
              dataSource={dataSourceCustomerEmail}
              showBorders={false}
              keyExpr="CONTACT_ID"
              onSelectionChanged={onSelectionChanged}
              ref={dataGridRef}
              selectedRowKeys={selectedRowKeys}
            >
              <Selection mode="multiple" />
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                width={240}
                placeholder="Full Text Search..."
              />
              <Column dataField="CARRIER_CODE" caption="CARRIER" />
              <Column dataField="CONTACT_NAME" caption="NAME" />
              <Column dataField="CONTACT_EMAIL" caption="EMAIL" />
            </DataGrid>
          </Grid>

          <Grid item xs={12} sm={12}>
            <label>Subject: </label>
            <TextField
              size="small"
              name="GET_SUBJECT_MAIL"
              variant="standard"
              fullWidth
              id="GET_SUBJECT_MAIL"
              value={GET_SUBJECT_MAIL}
              onChange={(e) => SET_SUBJECT_MAIL(e.target.value)}
            />
            {errors.SubjectMail && (
              <span className="error-message">{errors.SubjectMail}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <Button1
              disabled={!isButtonDisabled}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
             {GET_BUTTON_STR}
            </Button1>
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>Preview Email: </label>
            <hr />
            {ReactHtmlParser(GET_BODY_MAIL)}
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
